import "./DateFilter.scss";

import type { ChangeEvent } from "react";
import { useMemo } from "react";

import { useMediaQuery } from "../../../hooks/useMediaQuery";
import { useQueryParams } from "../../../hooks/useQueryParams";
import type { IOption } from "../../StyledSelect/StyledSelect";
import { StyledSelect } from "../../StyledSelect/StyledSelect";
import { DatePicker } from "./DatePicker";

export const oneDay = 24 * 60 * 60 * 1000;
export const oneMinute = 60 * 1000;
export interface Time {
  label: string;
  defaultChecked?: boolean;
}

interface IProps {
  items: Time[];
  customFirst?: boolean;
}

const FilterByDate: React.FC<IProps> = ({ items, customFirst }) => {
  const isMd = useMediaQuery("md");
  const { handleChange, queryValue } = useQueryParams({
    queryStr: "date",
  });
  const onChange = (e: ChangeEvent<HTMLInputElement>, time: Time) => {
    handleChange(time.label === "All" ? "" : e.target.value, true);
  };

  const onSelectChange = (opt: IOption) => {
    if (!opt) {
      handleChange("", true);
      return;
    }
    handleChange(opt.label === "All" ? "" : opt.value, true);
  };

  const options = useMemo(
    () =>
      items.map(item => ({
        value: `${item.label}`,
        label: item.label,
        timeLabel: item.label,
      })),
    [items],
  );

  const getContent = useMemo(() => {
    const content = items.map((time, index) => (
      <label key={index} className="date-filter-item">
        <input
          type="radio"
          name="date"
          value={`${time.label}`}
          className="date-filter__input"
          onChange={e => onChange(e, time)}
          checked={
            queryValue ? queryValue.includes(time.label) : !!time.defaultChecked
          }
          hidden
        />
        {time.label}
      </label>
    ));
    customFirst
      ? content.unshift(
          <DatePicker
            queryValue={queryValue || ""}
            handleChange={handleChange}
            key={-1}
          />,
        )
      : content.push(
          <DatePicker
            queryValue={queryValue || ""}
            handleChange={handleChange}
            key={-1}
          />,
        );
    return content;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [items, queryValue, handleChange, customFirst]);

  return (
    <div className="date-filter-wrap">
      {isMd ? (
        <StyledSelect
          options={options}
          isClearable={queryValue ? queryValue !== options[0].value : false}
          isDisabled={false}
          isLoading={false}
          isSearchable={false}
          onChange={onSelectChange}
          value={
            queryValue
              ? options.find(option =>
                  queryValue?.includes(option.timeLabel) ? option : null,
                )
              : customFirst
              ? options[options.length - 1]
              : options[0]
          }
        />
      ) : (
        <div className="date-filter">{getContent}</div>
      )}
      <div className="short-explanation w-100">
        <strong>Filter</strong> by date
      </div>
    </div>
  );
};

export { FilterByDate };
